var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-app"},[_c('sidebar-section'),_c('header-section'),_c('div',{attrs:{"id":"maincontent"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }